import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * El unico spinner del sistema. Decorativo (`aria-hidden`): el estado de carga
 * lo anuncia quien lo contiene (`Cargando` con `role="status"`, `Button` con
 * `aria-busy`), no el dibujo.
 */
export function Spinner({ className }: { className?: string }): JSX.Element {
  return <Loader2 className={cn("size-4 shrink-0 animate-spin", className)} aria-hidden="true" />;
}

export interface CargandoProps {
  /** Siempre con elipsis tipografica (U+2026), nunca tres puntos. */
  texto?: string;
  /** `bloque` ocupa el lugar de una lista o tabla; `inline` va dentro de una linea de texto. */
  tamano?: "inline" | "bloque";
  className?: string;
}

/**
 * Texto de espera fuera de un boton. Reemplaza a los "Cargando" sueltos (con
 * tres puntos a mano) y a los "Buscando" usados como mensaje vacio: si algo se
 * esta cargando, se muestra esto en el lugar del contenido, con `role="status"`
 * para que el lector de pantalla lo anuncie sin robar el foco.
 */
export function Cargando({
  texto = "Cargando…",
  tamano = "bloque",
  className,
}: CargandoProps): JSX.Element {
  if (tamano === "inline") {
    return (
      <span
        role="status"
        className={cn("inline-flex items-center gap-2 text-sm text-muted-foreground", className)}
      >
        <Spinner />
        {texto}
      </span>
    );
  }
  return (
    <div
      role="status"
      className={cn(
        "flex items-center justify-center gap-2 py-12 text-sm text-muted-foreground",
        className,
      )}
    >
      <Spinner />
      {texto}
    </div>
  );
}
